import {
  DataEntityPresenterModel,
  DataEntityTypeEnum,
  DataEntryPresenterModel,
  RefProperty,
  REQUEST_ENTITY_ID,
} from '@osos/shared/types';

export function isServiceEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.type === DataEntityTypeEnum.Service;
}

export function isRequestEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.type === DataEntityTypeEnum.Request;
}

export function isCoreRequestEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.id === REQUEST_ENTITY_ID;
}

export function isCoreUserEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.type === DataEntityTypeEnum.User;
}

export function getRequestEntryReference(
  entry: DataEntryPresenterModel,
): RefProperty {
  return entry?.value?.reference;
}

export function allowChangeUserPassword(
  userEntry: DataEntryPresenterModel,
): boolean {
  return userEntry?.value?.account_information?.isExternal ?? true;
}

export function isUserDeactivated(userEntry: DataEntryPresenterModel): boolean {
  return userEntry?.value?.is_deactivated ?? false;
}
